import { render } from "./UserManage.vue?vue&type=template&id=3216789f&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=3216789f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216789f"]])

export default __exports__